import { render, staticRenderFns } from "./InBox.vue?vue&type=template&id=7e29e257&scoped=true"
import script from "./InBox.vue?vue&type=script&lang=js"
export * from "./InBox.vue?vue&type=script&lang=js"
import style0 from "./InBox.vue?vue&type=style&index=0&id=7e29e257&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e29e257",
  null
  
)

export default component.exports